module.exports = __webpack_public_path__ + "app/principal/modals/modal-routing-code-2y-R-x04.html";